import { BadgeIcon } from "icons";
import React from "react";
import { Program } from "generated/graphql";
import { truncateMessage } from "utils";
import { Button } from "ui/Button";
import useText from "constants/text";
import { FidelityItemContainer, FidelityItemTitle, FidelityItemDescription, useFidelityItemStyle } from "../style";

const FidelityColor = {
  Bronze: {
    titleColor: "#966f5d",
    background: "rgba(174, 137, 119, 0.3)",
  },
  Silver: {
    titleColor: "#9199ab",
    background: "rgba(195, 202, 216, 0.3)",
  },
  Gold: {
    titleColor: "#99774d",
    background: "rgba(171, 140, 97, 0.3)",
  },
  Platinium: {
    titleColor: "#939292",
    background: " rgba(178, 177, 177, 0.3)",
  },
};

interface FidelityItemProps {
  onSelectItem: (item: Program) => void;
  program: Program;
}
function FidelityItem({ onSelectItem, program }: FidelityItemProps) {
  const styles = useFidelityItemStyle();
  const { text } = useText();
  return (
    <FidelityItemContainer onClick={() => onSelectItem(program)}>
      <img className="image" src={program?.iconUrl} alt={program?.title} />
      <FidelityItemTitle titleColor="#757a93">{program?.title}</FidelityItemTitle>
      <FidelityItemDescription>{truncateMessage(program?.description, 100)}</FidelityItemDescription>
      <Button className={styles.learnMoreButton}>{text.all.see_more}</Button>
      <div className="badge">
        <BadgeIcon color="rgba(171, 140, 97, 0.3)" height={100} width={100} />
      </div>
    </FidelityItemContainer>
  );
}

export default FidelityItem;
